var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app","lang":this.$i18n.locale}},[_c('router-view',{attrs:{"keep-alive":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }